import { createUseStyles } from "react-jss";
import _ from "lodash";
import jssVariables from "../../../../jss_setup";
import { Placeholder } from "../../../widgets/placeholder";

const styles = createUseStyles({
  PrebookLoader: (props) => ({
    boxShadow: jssVariables.shadows.normalShadow,
    padding: jssVariables.normal_gap,
    borderRadius: jssVariables.border_radius,
    overflow: "hidden",
    maxHeight: "66vh",
    ..._.get(props, "customStyles.PrebookUpdateLoader", {}),
  }),
  divider: (props) => ({
    height: "1px",
    width: "100%",
    background: jssVariables.colors.border,
    margin: `${jssVariables.double_gap} 0`,
    ..._.get(props, "customStyles.divider", {}),
  }),
  cols: (props) => ({
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gridGap: `calc(${jssVariables.normal_gap} * 4)`,
    ..._.get(props, "customStyles.cols", {}),
  }),
});
export const PrebookLoader = () => {
  const classes = styles();
  return (
    <div className={classes.PrebookLoader}>
      <Placeholder type="text" height={`calc(${jssVariables.normal_gap} * 3)`} width="100%" />
      <br />
      <Placeholder type="text" rows={3} />
      <div className={classes.divider} />
      <div className={classes.cols}>
        {new Array(3).fill(0).map((__, idx) => (
          <div key={`${idx}-${__}`}>
            <Placeholder type="text" rows={3} />
          </div>
        ))}
      </div>
      <div className={classes.divider} />
      <Placeholder type="text" rows={2} />
      <br />
      <Placeholder type="text" rows={2} />
    </div>
  );
};
